const initializeCurriculumSelector = () => {
  const curriculumSelector = document.getElementById('curriculum-selector');
  if (!curriculumSelector) return;

  // Initialize Select2
  $(curriculumSelector).select2({
    placeholder: 'Select curriculums to display...',
    allowClear: true
  });

  // Create button group container
  const buttonGroup = document.createElement('div');
  buttonGroup.className = 'btn-group';
  buttonGroup.style.marginRight = '10px';
  buttonGroup.style.flexShrink = '0';
  
  // Add AND/OR buttons
  const andButton = document.createElement('button');
  andButton.type = 'button';
  andButton.className = 'btn btn-sm';
  andButton.textContent = 'AND';
  andButton.style.backgroundColor = '#fff';  // Start as inactive
  andButton.style.border = '1px solid #ddd';
  andButton.style.minWidth = '40px';
  andButton.style.padding = '4px 8px';
  
  const orButton = document.createElement('button');
  orButton.type = 'button';
  orButton.className = 'btn btn-sm active';  // Start as active
  orButton.textContent = 'OR';
  orButton.style.backgroundColor = '#f5f5f5';  // Start as active
  orButton.style.border = '1px solid #ddd';
  orButton.style.minWidth = '40px';
  orButton.style.padding = '4px 8px';

  // Add buttons to button group
  buttonGroup.appendChild(andButton);
  buttonGroup.appendChild(orButton);

  // Find or create flex container
  const flexContainer = curriculumSelector.closest('div[style*="display: flex"]');
  if (flexContainer) {
    flexContainer.insertBefore(buttonGroup, flexContainer.firstChild);
  } else {
    const newFlexContainer = document.createElement('div');
    newFlexContainer.style.display = 'flex';
    newFlexContainer.style.alignItems = 'center';
    curriculumSelector.parentNode.insertBefore(newFlexContainer, curriculumSelector);
    newFlexContainer.appendChild(buttonGroup);
    newFlexContainer.appendChild(curriculumSelector);
  }

  let isAndMode = false;  // Start in OR mode

  const updateDisplay = () => {
    const selectedValues = $(curriculumSelector).val() || [];
    const table = document.querySelector('.students-table');
    const curriculumColumns = table.querySelectorAll('th[data-curriculum-id]');
    const totalElement = document.querySelector('h2');
    let visibleRows = 0;
    let totalRows = table.querySelectorAll('tbody tr').length;

    // Check if "Active Users Only" is enabled
    const activeButton = document.querySelector('#active-users-toggle button:last-child');
    const showActiveOnly = activeButton && activeButton.classList.contains('active');

    // Check if a specific "Disabled at" date is selected
    const dateFilter = document.getElementById('disabled-at-filter');
    const selectedDate = dateFilter ? dateFilter.value : 'all';
    const exactDateFilterActive = Boolean(selectedDate) && selectedDate !== 'all';

    const dateFromInput = document.getElementById('disabled-at-from');
    const dateToInput = document.getElementById('disabled-at-to');
    const rangeBounds = document.getElementById('disabled-at-filters');
    const rangeMin = rangeBounds ? rangeBounds.dataset.min : '';
    const rangeMax = rangeBounds ? rangeBounds.dataset.max : '';
    const dateFrom = dateFromInput && dateFromInput.value ? dateFromInput.value : rangeMin;
    const dateTo = dateToInput && dateToInput.value ? dateToInput.value : rangeMax;
    const rangeFilterActive = Boolean(rangeBounds) &&
      ((dateFrom && dateFrom > rangeMin) || (dateTo && dateTo < rangeMax));
    const dateFilterActive = exactDateFilterActive || rangeFilterActive;

    console.log('Selected curriculums:', selectedValues);
    console.log('AND mode:', isAndMode);
    console.log('Show active only:', showActiveOnly);

    // Helper function to check if a student has access to a curriculum
    const hasCurriculumAccess = (cell) => {
      if (!cell) {
        console.log('Cell not found');
        return false;
      }
      const hasAccess = cell.dataset.hasAccess === 'true';
      console.log('Has curriculum access:', hasAccess);
      return hasAccess;
    };

    // Helper function to check if a row is active
    const isRowActive = (row) => {
      const activeCell = row.querySelector('.user-active-status');
      return activeCell && activeCell.dataset.active === 'true';
    };

    // Hide all curriculum columns first
    curriculumColumns.forEach(column => {
      const columnId = column.dataset.curriculumId;
      const cells = table.querySelectorAll(`[data-curriculum-id="${columnId}"]`);
      cells.forEach(cell => cell.classList.add('hidden'));
    });

    // Show selected columns
    if (selectedValues.includes('all') || selectedValues.length === 0) {
      curriculumColumns.forEach(column => {
        const columnId = column.dataset.curriculumId;
        const cells = table.querySelectorAll(`[data-curriculum-id="${columnId}"]`);
        if (selectedValues.includes('all')) {
          cells.forEach(cell => cell.classList.remove('hidden'));
        }
      });
    } else {
      selectedValues.forEach(curriculumId => {
        const cells = table.querySelectorAll(`[data-curriculum-id="${curriculumId}"]`);
        cells.forEach(cell => cell.classList.remove('hidden'));
      });
    }

    // Filter and show/hide rows
    const rows = table.querySelectorAll('tbody tr');
    rows.forEach(row => {
      let shouldShowRow = true;
      const studentId = row.querySelector('td:nth-child(2)')?.textContent?.trim();
      console.log('\nChecking student:', studentId);

      // Apply active users filter first if enabled
      if (showActiveOnly) {
        shouldShowRow = isRowActive(row);
        console.log('Active filter:', shouldShowRow);
      }

      // Apply the "Disabled at" date filter if a specific date is selected
      if (shouldShowRow && exactDateFilterActive) {
        shouldShowRow = row.dataset.disabledAt === selectedDate;
        console.log('Disabled at exact filter:', shouldShowRow);
      }

      // Apply the "Disabled at" from/to range when it is narrower than the full span
      if (shouldShowRow && rangeFilterActive) {
        const rowDate = row.dataset.disabledAt;
        shouldShowRow = Boolean(rowDate) && rowDate >= dateFrom && rowDate <= dateTo;
        console.log('Disabled at range filter:', shouldShowRow);
      }

      // Then apply curriculum filter if any specific curriculums are selected
      if (shouldShowRow && selectedValues.length > 0 && !selectedValues.includes('all')) {
        if (isAndMode) {
          // AND mode: Must have access to all selected curriculums
          shouldShowRow = selectedValues.every(curriculumId => {
            const curriculumCell = row.querySelector(`td[data-curriculum-id="${curriculumId}"]`);
            console.log(`Checking curriculum ${curriculumId} for student ${studentId}:`, curriculumCell);
            const hasAccessResult = hasCurriculumAccess(curriculumCell);
            console.log('AND mode - Curriculum:', curriculumId, 'Has access:', hasAccessResult);
            return hasAccessResult;
          });
          console.log('AND mode final result:', shouldShowRow);
        } else {
          // OR mode: Must have access to at least one selected curriculum
          shouldShowRow = selectedValues.some(curriculumId => {
            const curriculumCell = row.querySelector(`td[data-curriculum-id="${curriculumId}"]`);
            console.log(`Checking curriculum ${curriculumId} for student ${studentId}:`, curriculumCell);
            const hasAccessResult = hasCurriculumAccess(curriculumCell);
            console.log('OR mode - Curriculum:', curriculumId, 'Has access:', hasAccessResult);
            return hasAccessResult;
          });
          console.log('OR mode final result:', shouldShowRow);
        }
      }

      // Force the display style and prevent other handlers from changing it
      const displayValue = shouldShowRow ? 'table-row' : 'none';
      console.log(`Setting display for student ${studentId} to:`, displayValue);
      
      // Use !important to prevent other styles from overriding
      row.style.setProperty('display', displayValue, 'important');
      console.log(`After setting, display is:`, row.style.display);
      
      if (shouldShowRow) {
        visibleRows++;
        console.log('Student will be shown:', studentId);
      } else {
        console.log('Student will be hidden:', studentId);
      }
    });

    // Update total with filtered count
    if (totalElement) {
      const showFilteredTotal = showActiveOnly || dateFilterActive || (selectedValues.length > 0 && !selectedValues.includes('all'));
      totalElement.textContent = showFilteredTotal ? `Total : ${visibleRows} / ${totalRows}` : `Total : ${visibleRows}`;
      console.log('Final counts - Visible:', visibleRows, 'Total:', totalRows);
    }

    // Double check visibility
    setTimeout(() => {
      rows.forEach(row => {
        const studentId = row.querySelector('td:nth-child(2)')?.textContent?.trim();
        console.log(`Visibility check - Student ${studentId}:`, row.style.display);
      });
    }, 100);
  };

  // Event listeners
  andButton.addEventListener('click', function() {
    if (!this.classList.contains('active')) {
      this.classList.add('active');
      this.style.backgroundColor = '#f5f5f5';
      orButton.classList.remove('active');
      orButton.style.backgroundColor = '#fff';
      isAndMode = true;
      updateDisplay();
    }
  });

  orButton.addEventListener('click', function() {
    if (!this.classList.contains('active')) {
      this.classList.add('active');
      this.style.backgroundColor = '#f5f5f5';
      andButton.classList.remove('active');
      andButton.style.backgroundColor = '#fff';
      isAndMode = false;
      updateDisplay();
    }
  });

  // Handle the select all option separately
  $(curriculumSelector).on('select2:select', function(e) {
    if (e.params.data.id === 'all') {
      // If "All Curriculums" is selected, deselect everything else
      const allOption = $(this).find('option[value="all"]');
      $(this).find('option').prop('selected', false);
      allOption.prop('selected', true);
      $(this).trigger('change');
    } else {
      // If another option is selected, deselect "All Curriculums"
      $(this).find('option[value="all"]').prop('selected', false);
      $(this).trigger('change');
    }
  });

  // Bind the update function to the change event
  $(curriculumSelector).on('change', updateDisplay);

  // Re-run filtering when the "Disabled at" date filters change
  const disabledAtFilter = document.getElementById('disabled-at-filter');
  if (disabledAtFilter) {
    disabledAtFilter.addEventListener('change', updateDisplay);
  }

  const clampDisabledAtRange = (changedInput) => {
    const fromInput = document.getElementById('disabled-at-from');
    const toInput = document.getElementById('disabled-at-to');
    const rangeBounds = document.getElementById('disabled-at-filters');
    if (!fromInput || !toInput || !rangeBounds) return;

    const overallMin = rangeBounds.dataset.min;
    const overallMax = rangeBounds.dataset.max;

    if (fromInput.value && toInput.value && fromInput.value > toInput.value) {
      if (changedInput === fromInput) {
        toInput.value = fromInput.value;
      } else {
        fromInput.value = toInput.value;
      }
    }

    fromInput.min = overallMin;
    fromInput.max = toInput.value || overallMax;
    toInput.min = fromInput.value || overallMin;
    toInput.max = overallMax;
  };

  ['disabled-at-from', 'disabled-at-to'].forEach((id) => {
    const input = document.getElementById(id);
    if (!input) return;
    input.addEventListener('change', function() {
      clampDisabledAtRange(this);
      updateDisplay();
    });
  });

  // Set initial selection based on total number of users
  const totalUsers = parseInt(curriculumSelector.dataset.totalUsers || '0', 10);
  const curriculumColumns = document.querySelectorAll('th[data-curriculum-id]');
  
  if (totalUsers < 20) {
    // If less than 20 users, don't select any curriculum by default
    $(curriculumSelector).val(null);
    $(curriculumSelector).trigger('change.select2');
    updateDisplay();
  } else {
    // If 20 or more users, select first 4 curriculums (default behavior)
    const firstFourColumns = Array.from(curriculumColumns).slice(0, 4);
    const firstFourValues = firstFourColumns.map(col => col.dataset.curriculumId);
    
    // Set the initial values and trigger both select2 and regular change
    $(curriculumSelector).val(firstFourValues);
    $(curriculumSelector).trigger('change.select2');
    updateDisplay();
  }
};

// Export the initialization function
export { initializeCurriculumSelector }; 